@if (decorations$ | async; as allDecorations) {
  <div class="decorations">
    <div
      (click)="pick({ decorationForClientId: null })"
      [ngClass]="{
        picked: null === model.value.decorationId,
      }"
      class="decoration"
    >
      <h1>Brak</h1>
    </div>
    @for (decoration of allDecorations; track decoration; let i = $index) {
      <div
        (click)="customLinesCount = decoration.fields.length; pick(decoration)"
        [ngClass]="{
          picked: decoration.decorationForClientId === model.value.decorationId,
        }"
        [title]="decoration.label | langPicker | async"
        class="decoration"
      >
        <div
          [ngStyle]="{
            backgroundImage:
              'url(' +
              ({ decorations: allDecorations, personalization: model.value }
                | getDecorationsBg: firstLabelsLoad$
                | async) +
              ')',
            backgroundPosition: '0 ' + (iconSize$ | async) * -i + 'px',
          }"
          class="bg"
        ></div>
      </div>
    }
  </div>
}
@if (firstLabelsLoad$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<button
  (click)="zalamoDialogService.openRight(editPersonalization)"
  *libIsHandset="personalization"
  class="personalizationOnMobileButton"
  mat-mini-fab
>
  <mat-icon>edit</mat-icon>
</button>

<ng-template #personalization>
  @if (model.value.decorationId) {
    <div
      [ngClass]="{ custom: model.value.personalizationMode === 'custom' }"
      class="personalization"
    >
      <mat-form-field libZalamoField [noBottomMargin]="true" class="mode">
        <mat-select [formControl]="model.controls.personalizationMode">
          <mat-option value="fromType">Szablony</mat-option>
          <mat-option value="custom">Własna kompozycja</mat-option>
        </mat-select>
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
      @if (model.value.personalizationMode === 'fromType') {
        <ng-container [formGroup]="model">
          @if (hasFirstName$ | async) {
            <mat-form-field>
              <mat-label>Pierwsze imię</mat-label>
              <input formControlName="firstName" matInput />
            </mat-form-field>
          }
          @if (hasLastName$ | async) {
            <mat-form-field>
              <mat-label>Drugie imię</mat-label>
              <input formControlName="secondName" matInput />
            </mat-form-field>
          }
          @if (hasDate$ | async) {
            <mat-form-field>
              <mat-label>Data</mat-label>
              <input formControlName="date" matInput />
            </mat-form-field>
          }
          @if (hasConnector$ | async) {
            <mat-form-field>
              <mat-label>Lącznik</mat-label>
              <input formControlName="connector" matInput />
            </mat-form-field>
          }
        </ng-container>
      } @else {
        @for (line of lines.controls; track line; let i = $index) {
          <mat-form-field libZalamoField [noBottomMargin]="true">
            <mat-label>Pole {{ i + 1 }}</mat-label>
            <input [formControl]="line" matInput type="text" />
            <lib-zalamo-field-decoration></lib-zalamo-field-decoration
          ></mat-form-field>
        }
      }
    </div>
  }
</ng-template>
<ng-template #editPersonalization>
  <div class="personalizationModal">
    <mat-dialog-content>
      <ng-container *ngTemplateOutlet="personalization"></ng-container>
    </mat-dialog-content>
    <mat-dialog-actions>
      <lib-button mat-dialog-close>Zamknij</lib-button>
    </mat-dialog-actions>
  </div>
</ng-template>
